import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { putRegisterPassword } from '../../../api/login'
import { ReactComponent as Pencil } from '../../../assets/icons/pencil.svg'
import { useUserProfileStore } from '../../../stores/userProfileStore'

import styles from './change-password.module.scss'

function ChangePassword() {
    const { t } = useTranslation()

    const [{ userProfile }] = useUserProfileStore()
    const { email } = userProfile

    const [oldPassword, setOldPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [repeatedNewPassword, setRepeatedNewPassword] = useState('')

    const saveChanges = (e?: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault()

        if (!newPassword || newPassword !== repeatedNewPassword) {
            toast(() => t('password_repeated_error'))
            return
        }

        putRegisterPassword(email, oldPassword, newPassword).then(() => {
            setOldPassword('')
            setNewPassword('')
            setRepeatedNewPassword('')
        })
    }

    return (
        <form className={styles.changePassword} onSubmit={saveChanges}>
            <div className={styles.changePassword__header}>
                <Pencil />
                {t('change_password')}
            </div>
            <label
                className={styles.changePassword__label}
                htmlFor="oldPassword"
            >
                {t('old_password')}
                <input
                    className={styles.changePassword__input}
                    name="oldPassword"
                    id="oldPassword"
                    placeholder={t('password')}
                    type="password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                />
            </label>
            <label
                className={styles.changePassword__label}
                htmlFor="newPassword"
            >
                {t('new_password')}
                <input
                    className={styles.changePassword__input}
                    name="newPassword"
                    id="newPassword"
                    placeholder={t('new_password')}
                    type="password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
            </label>
            <label
                className={styles.changePassword__label}
                htmlFor="repeatedNewPassword"
            >
                {t('repeat_new_password')}
                <input
                    className={styles.changePassword__input}
                    name="repeatedNewPassword"
                    id="repeatedNewPassword"
                    placeholder={t('repeat_new_password')}
                    type="password"
                    value={repeatedNewPassword}
                    onChange={(e) => setRepeatedNewPassword(e.target.value)}
                />
            </label>
            <button className={styles.changePassword__btn} type="submit">
                {t('confirm')}
            </button>
        </form>
    )
}

export default ChangePassword
